import { applyVueInReact } from 'vuereact-combined';

import RouterView from '@/components/common/RouterViewWrapper.vue';

const ReactRouterView = applyVueInReact(RouterView);

const RouterViewComponent = () => <ReactRouterView></ReactRouterView>;

export default RouterViewComponent;
